import { render, staticRenderFns } from "./AttachmentAddMdok.vue?vue&type=template&id=20e3304c&"
import script from "./AttachmentAddMdok.vue?vue&type=script&lang=js&"
export * from "./AttachmentAddMdok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports